/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Companion_S1Inputs */

const en_lg_companion_s1 = /** @type {(inputs: Lg_Companion_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the setup guide, download the ZIP, and extract it to a permanent folder. In Chrome, open chrome://extensions, enable Developer mode, then choose Load unpacked and that folder.`)
};

const id_lg_companion_s1 = /** @type {(inputs: Lg_Companion_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka panduan pemasangan, unduh ZIP, dan ekstrak ke folder tetap. Di Chrome, buka chrome://extensions, aktifkan Developer mode, lalu pilih Load unpacked dan folder tadi.`)
};

/**
* | output |
* | --- |
* | "Open the setup guide, download the ZIP, and extract it to a permanent folder. In Chrome, open chrome://extensions, enable Developer mode, then choose Load un..." |
*
* @param {Lg_Companion_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_companion_s1 = /** @type {((inputs?: Lg_Companion_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Companion_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_companion_s1(inputs)
	return en_lg_companion_s1(inputs)
});